import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth/auth.guard';
import { AppUpdateGuard } from './shared/guards/auth';

export const APP_UPDATE_ROUTE: Route = {
  path: 'app-update',
  loadChildren: () =>
    import('./core/auth/app-update/app-update-routing.module').then(
      (m) => m.AppUpdateRoutingModule
    ),
};

const routes: Routes = [
  { path: '', redirectTo: 'admin', pathMatch: 'full' },
  {
    path: 'admin',
    canActivate: [AuthGuard, AppUpdateGuard],
    loadChildren: () =>
      import('./core/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'auth',
    canActivate: [AppUpdateGuard],
    loadChildren: () =>
      import('./core/auth/auth.module').then((m) => m.AuthModule),
  },
  APP_UPDATE_ROUTE,
  { path: '**', redirectTo: '/admin' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
